import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"

const RecruitNewsList = ({ className }) => {
  const data = useStaticQuery(//ページコンポーネント以外ではuseStaticQueryを利用してgraphqlが利用できる
    graphql`
    query {
   allWpPost(
     sort: { fields: [modified] , order: DESC}
    filter: { categories: { nodes: { elemMatch: { slug: { eq: "recruit-news" } } } } }
     skip: 0
     limit: 3 ) {
     edges {
       node {
         id
         title
         link
         date(formatString: "YYYY.MM.DD")
         modified(formatString: "YYYY/MM/DD")
         categories {
           nodes {
             name
             slug
           }
         }
         excerpt
         slug
         featuredImage {
           node {
             localFile {
               childImageSharp {
                 fluid(maxWidth: 1024) {
                   ...GatsbyImageSharpFluid_withWebp_tracedSVG
                 }
               }
             }
           }
         }
       }
     }
   }
 }
`
  )
  return (
    <div className={className}>
      <ul>
        {data.allWpPost.edges.map(({ node }) => (
          <li key={node.title} className={`ListItem`}>
            <Link to={node.link}>
              <div className={`ListMeta`}>
                <span>{node.date}</span>
              </div>
              <h3>{node.title}</h3>
            </Link>
          </li>
        ))}
      </ul>
    </div>

  )
}
export default RecruitNewsList;

